var badgeList=
[
    {
        "key": "c",
        "badge": "C",
        "color": "A8B9CC",
        "text": "Clang",
        "url0": "https://clang.llvm.org/",
        "url1": "https://xconst.com"
    },
    {
        "key": "cs",
        "badge": "C%23",
        "color": "512BD4",
        "text": "C%23",
        "url0": "https://docs.microsoft.com/en-us/dotnet/csharp/",
        "url1": "https://xconst.com"
    },
    {
        "key": "cpp",
        "badge": "C%2B%2B",
        "color": "00599C",
        "text": "C%2B%2B",
        "url0": "https://isocpp.org/",
        "url1": "https://xconst.com"
    },
    {
        "key": "java",
        "badge": "Ko-fi",
        "color": "FF5E5B",
        "text": "Java",
        "url0": "https://www.java.com/",
        "url1": "https://xconst.com"
    },
    {
        "key": "html5",
        "badge": "HTML5",
        "color": "E34F26",
        "text": "HTML5",
        "url0": "https://html.spec.whatwg.org/",
        "url1": "https://xconst.com"
    },
    {
        "key": "css3",
        "badge": "CSS3",
        "color": "1572B6",
        "text": "CSS3",
        "url0": "https://www.w3.org/Style/CSS/Overview.en.html",
        "url1": "https://xconst.com"
    },
    {
        "key": "less",
        "badge": "Less",
        "color": "1D365D",
        "text": "Less",
        "url0": "http://lesscss.org/",
        "url1": "https://xconst.com"
    },
    {
        "key": "javascript",
        "badge": "JavaScript",
        "color": "F7DF1E",
        "text": "JavaScript",
        "url0": "https://developer.mozilla.org/en-US/docs/Web/JavaScript",
        "url1": "https://xconst.com"
    },
    {
        "key": "python",
        "badge": "Python",
        "color": "3776AB",
        "text": "Python",
        "url0": "https://www.python.org/",
        "url1": "https://xconst.com"
    },
    {
        "key": "kotlin",
        "badge": "Kotlin",
        "color": "7F52FF",
        "text": "Kotlin",
        "url0": "https://kotlinlang.org/",
        "url1": "https://xconst.com"
    },
    {
        "key": "go",
        "badge": "Go",
        "color": "00ADD8",
        "text": "Go",
        "url0": "https://golang.org/",
        "url1": "https://xconst.com"
    },
    {
        "key": "node.js",
        "badge": "Node.js",
        "color": "339933",
        "text": "Node.js",
        "url0": "https://nodejs.org/",
        "url1": "https://xconst.com"
    },
    {
        "key": "markdown",
        "badge": "Markdown",
        "color": "000000",
        "text": "Markdown",
        "url0": "https://www.markdownguide.org/",
        "url1": "https://xconst.com"
    },
    {
        "key": "react",
        "badge": "React",
        "color": "61DAFB",
        "text": "React",
        "url0": "https://reactjs.org/",
        "url1": "https://xconst.com"
    },
    {
        "key": "vuejs",
        "badge": "Vue.js",
        "color": "4FC08D",
        "text": "Vue.js",
        "url0": "https://vuejs.org/",
        "url1": "https://xconst.com"
    },
    {
        "key": "mysql",
        "badge": "MySQL",
        "color": "4479A1",
        "text": "MySQL",
        "url0": "https://www.mysql.com/",
        "url1": "https://xconst.com"
    },
    {
        "key": "postgresql",
        "badge": "PostgreSQL",
        "color": "4169E1",
        "text": "PostgreSQL",
        "url0": "https://www.postgresql.org/",
        "url1": "https://xconst.com"
    },
    {
        "key": "pytorch",
        "badge": "PyTorch",
        "color": "EE4C2C",
        "text": "PyTorch",
        "url0": "https://pytorch.org/",
        "url1": "https://xconst.com"
    },
    {
        "key": "fontawesome",
        "badge": "FontAwesome",
        "color": "528DD7",
        "text": "FontAwesome",
        "url0": "https://fontawesome.com/",
        "url1": "https://xconst.com"
    },
    {
        "key": "lodash",
        "badge": "Lodash",
        "color": "3492FF",
        "text": "Lodash",
        "url0": "https://lodash.com/",
        "url1": "https://xconst.com"
    },
    {
        "key": "swiper",
        "badge": "Swiper",
        "color": "6332F6",
        "text": "Swiper",
        "url0": "https://swiperjs.com/",
        "url1": "https://xconst.com"
    },
    {
        "key": "qt",
        "badge": "Qt",
        "color": "41CD52",
        "text": "Qt",
        "url0": "https://www.qt.io/",
        "url1": "https://xconst.com"
    },
    {
        "key": "numpy",
        "badge": "NumPy",
        "color": "013243",
        "text": "NumPy",
        "url0": "https://numpy.org/",
        "url1": "https://xconst.com"
    },
    {
        "key": "materialdesignicons",
        "badge": "MaterialDesignIcons",
        "color": "2196F3",
        "text": "MaterialDesignIcons",
        "url0": "https://materialdesignicons.com/",
        "url1": "https://xconst.com"
    },
    {
        "key": "apachetomcat",
        "badge": "ApacheTomcat",
        "color": "F8DC75",
        "text": "ApacheTomcat",
        "url0": "https://tomcat.apache.org/",
        "url1": "https://xconst.com"
    },
    {
        "key": "docker",
        "badge": "Docker",
        "color": "2496ED",
        "text": "Docker",
        "url0": "https://www.docker.com/",
        "url1": "https://xconst.com"
    },
    {
        "key": "magisk",
        "badge": "Magisk",
        "color": "00AF9C",
        "text": "Magisk",
        "url0": "https://magiskmanager.com/",
        "url1": "https://xconst.com"
    },
    {
        "key": "openlayers",
        "badge": "Openlayers",
        "color": "1F6B75",
        "text": "Openlayers",
        "url0": "https://openlayers.org/",
        "url1": "https://xconst.com"
    },
    {
        "key": "redis",
        "badge": "Redis",
        "color": "DC382D",
        "text": "Redis",
        "url0": "https://redis.io/",
        "url1": "https://xconst.com"
    },
    {
        "key": "axios",
        "badge": "Axios",
        "color": "5A29E4",
        "text": "Axios",
        "url0": "https://axios-http.com/",
        "url1": "https://xconst.com"
    },
    {
        "key": "android",
        "badge": "Android",
        "color": "34A853",
        "text": "Android",
        "url0": "https://developer.android.com/",
        "url1": "https://xconst.com"
    },
    {
        "key": "sphinx",
        "badge": "Sphinx",
        "color": "000000",
        "text": "Sphinx",
        "url0": "https://www.sphinx-doc.org/",
        "url1": "https://xconst.com"
    },
    {
        "key": "spring",
        "badge": "Spring",
        "color": "6DB33F",
        "text": "Spring",
        "url0": "https://spring.io/",
        "url1": "https://xconst.com"
    },
    {
        "key": "springsecurity",
        "badge": "SpringSecurity",
        "color": "6DB33F",
        "text": "SpringSecurity",
        "url0": "https://spring.io/projects/spring-security",
        "url1": "https://xconst.com"
    },
    {
        "key": "springboot",
        "badge": "SpringBoot",
        "color": "6DB33F",
        "text": "SpringBoot",
        "url0": "https://spring.io/projects/spring-boot",
        "url1": "https://xconst.com"
    },
    {
        "key": "django",
        "badge": "Django",
        "color": "092E20",
        "text": "Django",
        "url0": "https://www.djangoproject.com/",
        "url1": "https://xconst.com"
    },
    {
        "key": "googlecolab",
        "badge": "GoogleColab",
        "color": "F9AB00",
        "text": "GoogleColab",
        "url0": "https://colab.research.google.com/",
        "url1": "https://xconst.com"
    },
    {
        "key": "googleearthengine",
        "badge": "GoogleEarthEngine",
        "color": "4285F4",
        "text": "GoogleEarthEngine",
        "url0": "https://earthengine.google.com/",
        "url1": "https://xconst.com"
    },
    {
        "key": "jetbrains",
        "badge": "JetBrains",
        "color": "000000",
        "text": "JetBrains",
        "url0": "https://www.jetbrains.com/",
        "url1": "https://xconst.com"
    },
    {
        "key": "intellijidea",
        "badge": "IntelliJIDEA",
        "color": "000000",
        "text": "IntelliJIDEA",
        "url0": "https://www.jetbrains.com/idea/",
        "url1": "https://xconst.com"
    },
    {
        "key": "pycharm",
        "badge": "PyCharm",
        "color": "000000",
        "text": "PyCharm",
        "url0": "https://www.jetbrains.com/pycharm/",
        "url1": "https://xconst.com"
    },
    {
        "key": "clion",
        "badge": "CLion",
        "color": "000000",
        "text": "CLion",
        "url0": "https://www.jetbrains.com/clion/",
        "url1": "https://xconst.com"
    },
    {
        "key": "visualstudio",
        "badge": "VisualStudio",
        "color": "5C2D91",
        "text": "VisualStudio",
        "url0": "https://visualstudio.microsoft.com/",
        "url1": "https://xconst.com"
    },
    {
        "key": "visualstudiocode",
        "badge": "VisualStudioCode",
        "color": "007ACC",
        "text": "VisualStudioCode",
        "url0": "https://code.visualstudio.com/",
        "url1": "https://xconst.com"
    },
    {
        "key": "androidstudio",
        "badge": "AndroidStudio",
        "color": "3DDC84",
        "text": "AndroidStudio",
        "url0": "https://developer.android.com/studio",
        "url1": "https://xconst.com"
    },
    {
        "key": "vmware",
        "badge": "VMware",
        "color": "607078",
        "text": "VMware",
        "url0": "https://www.vmware.com/",
        "url1": "https://xconst.com"
    },
    {
        "key": "dbeaver",
        "badge": "DBeaver",
        "color": "382923",
        "text": "DBeaver",
        "url0": "https://dbeaver.io/",
        "url1": "https://xconst.com"
    },
    {
        "key": "postman",
        "badge": "Postman",
        "color": "FF6C37",
        "text": "Postman",
        "url0": "https://www.postman.com/",
        "url1": "https://xconst.com"
    },
    {
        "key": "insomnia",
        "badge": "Insomnia",
        "color": "4000BF",
        "text": "Insomnia",
        "url0": "https://insomnia.rest/",
        "url1": "https://xconst.com"
    },
    {
        "key": "git",
        "badge": "Git",
        "color": "F05032",
        "text": "Git",
        "url0": "https://git-scm.com/",
        "url1": "https://xconst.com"
    },
    {
        "key": "apple",
        "badge": "Apple",
        "color": "000000",
        "text": "Apple",
        "url0": "https://www.apple.com/",
        "url1": "https://xconst.com"
    },
    {
        "key": "xiaomi",
        "badge": "Xiaomi",
        "color": "FF6900",
        "text": "Xiaomi",
        "url0": "https://www.mi.com/",
        "url1": "https://xconst.com"
    },
    {
        "key": "nike",
        "badge": "Nike",
        "color": "111111",
        "text": "Nike",
        "url0": "https://www.nike.com/",
        "url1": "https://xconst.com"
    },
    {
        "key": "adidas",
        "badge": "Adidas",
        "color": "000000",
        "text": "Adidas",
        "url0": "https://www.adidas.com/",
        "url1": "https://xconst.com"
    },
    {
        "key": "huawei",
        "badge": "Huawei",
        "color": "FF0000",
        "text": "Huawei",
        "url0": "https://consumer.huawei.com/",
        "url1": "https://xconst.com"
    },
    {
        "key": "samsung",
        "badge": "Samsung",
        "color": "1428A0",
        "text": "Samsung",
        "url0": "https://www.samsung.com/",
        "url1": "https://xconst.com"
    },
    {
        "key": "oneplus",
        "badge": "OnePlus",
        "color": "F5010C",
        "text": "OnePlus",
        "url0": "https://www.oneplus.com/",
        "url1": "https://xconst.com"
    },
    {
        "key": "googletranslate",
        "badge": "GoogleTranslate",
        "color": "4285F4",
        "text": "GoogleTranslate",
        "url0": "https://translate.google.com/",
        "url1": "https://xconst.com"
    },
    {
        "key": "speedtest",
        "badge": "Speedtest",
        "color": "141526",
        "text": "Speedtest",
        "url0": "https://www.speedtest.net/",
        "url1": "https://xconst.com"
    },
    {
        "key": "neteasecloudmusic",
        "badge": "NetEaseCloudMusic",
        "color": "D43C33",
        "text": "NetEaseCloudMusic",
        "url0": "https://music.163.com/",
        "url1": "https://xconst.com"
    },
    {
        "key": "googlechrome",
        "badge": "GoogleChrome",
        "color": "4285F4",
        "text": "GoogleChrome",
        "url0": "https://www.google.com/chrome/",
        "url1": "https://xconst.com"
    },
    {
        "key": "googletasks",
        "badge": "GoogleTasks",
        "color": "2684FC",
        "text": "GoogleTasks",
        "url0": "https://workspace.google.com/products/tasks/",
        "url1": "https://xconst.com"
    },
    {
        "key": "microsoftbing",
        "badge": "MicrosoftBing",
        "color": "258FFA",
        "text": "MicrosoftBing",
        "url0": "https://www.bing.com/",
        "url1": "https://xconst.com"
    },
    {
        "key": "cloudflarepages",
        "badge": "CloudflarePages",
        "color": "F38020",
        "text": "CloudflarePages",
        "url0": "https://pages.cloudflare.com/",
        "url1": "https://xconst.com"
    },
    {
        "key": "githubpages",
        "badge": "GitHubPages",
        "color": "222222",
        "text": "GitHubPages",
        "url0": "https://pages.github.com/",
        "url1": "https://xconst.com"
    },
    {
        "key": "linux",
        "badge": "Linux",
        "color": "FCC624",
        "text": "Linux",
        "url0": "https://www.linux.org/",
        "url1": "https://xconst.com"
    },
    {
        "key": "ubuntu",
        "badge": "Ubuntu",
        "color": "E95420",
        "text": "Ubuntu",
        "url0": "https://ubuntu.com/",
        "url1": "https://xconst.com"
    },
    {
        "key": "windows10",
        "badge": "Windows10",
        "color": "0078D6",
        "text": "Windows10",
        "url0": "https://www.microsoft.com/en-us/windows/",
        "url1": "https://xconst.com"
    },
    {
        "key": "e",
        "badge": "/e/",
        "color": "000000",
        "text": "/e/",
        "url0": "https://e.foundation/",
        "url1": "https://xconst.com"
    },
    {
        "key": "github",
        "badge": "GitHub",
        "color": "181717",
        "text": "GitHub",
        "url0": "https://github.com/",
        "url1": "https://xconst.com"
    },
    {
        "key": "cloudflare",
        "badge": "Cloudflare",
        "color": "F38020",
        "text": "Cloudflare",
        "url0": "https://www.cloudflare.com/",
        "url1": "https://xconst.com"
    },
    {
        "key": "google",
        "badge": "Google",
        "color": "4285F4",
        "text": "Google",
        "url0": "https://www.google.com/",
        "url1": "https://xconst.com"
    },
    {
        "key": "meta",
        "badge": "Meta",
        "color": "0467DF",
        "text": "Meta",
        "url0": "https://meta.stackexchange.com/",
        "url1": "https://xconst.com"
    },
    {
        "key": "meituan",
        "badge": "Meituan",
        "color": "FFD100",
        "text": "Meituan",
        "url0": "https://www.meituan.com/",
        "url1": "https://xconst.com"
    },
    {
        "key": "openai",
        "badge": "OpenAI",
        "color": "412991",
        "text": "OpenAI",
        "url0": "https://openai.com/",
        "url1": "https://xconst.com"
    },
    {
        "key": "nvidia",
        "badge": "NVIDIA",
        "color": "76B900",
        "text": "NVIDIA",
        "url0": "https://www.nvidia.com/",
        "url1": "https://xconst.com"
    },
    {
        "key": "spacex",
        "badge": "SpaceX",
        "color": "000000",
        "text": "SpaceX",
        "url0": "https://www.spacex.com/",
        "url1": "https://xconst.com"
    },
    {
        "key": "opensourceinitiative",
        "badge": "OpenSourceInitiative",
        "color": "3DA639",
        "text": "OpenSourceInitiative",
        "url0": "https://opensource.org/",
        "url1": "https://xconst.com"
    },
    {
        "key": "opensourcehardware",
        "badge": "OpenSourceHardware",
        "color": "0099B0",
        "text": "OpenSourceHardware",
        "url0": "https://www.oshwa.org/",
        "url1": "https://xconst.com"
    },
    {
        "key": "bilibili",
        "badge": "Bilibili",
        "color": "00A1D6",
        "text": "Bilibili",
        "url0": "https://www.bilibili.com/",
        "url1": "https://xconst.com"
    },
    {
        "key": "gmail",
        "badge": "Gmail",
        "color": "EA4335",
        "text": "Gmail",
        "url0": "https://mail.google.com/",
        "url1": "https://xconst.com"
    },
    {
        "key": "instagram",
        "badge": "Instagram",
        "color": "E4405F",
        "text": "Instagram",
        "url0": "https://www.instagram.com/",
        "url1": "https://xconst.com"
    },
    {
        "key": "twitter",
        "badge": "Twitter",
        "color": "1D9BF0",
        "text": "Twitter",
        "url0": "https://twitter.com/",
        "url1": "https://xconst.com"
    },
    {
        "key": "twitch",
        "badge": "Twitch",
        "color": "9146FF",
        "text": "Twitch",
        "url0": "https://www.twitch.tv/",
        "url1": "https://xconst.com"
    },
    {
        "key": "x",
        "badge": "X",
        "color": "000000",
        "text": "X",
        "url0": "https://www.x.org/",
        "url1": "https://xconst.com"
    },
    {
        "key": "nginx",
        "badge": "NGINX",
        "color": "009639",
        "text": "NGINX",
        "url0": "https://www.nginx.com/",
        "url1": "https://xconst.com"
    },
        {
        "key": "kafka",
        "badge": "Apache Kafka",
        "color": "231F20",
        "text": "Apache Kafka",
        "url0": "https://kafka.apache.org/",
        "url1": "https://xconst.com"
    },
    {
        "key": "echarts",
        "badge": "Apache ECharts",
        "color": "AA344D",
        "text": "Apache ECharts",
        "url0": "https://echarts.apache.org/",
        "url1": "https://xconst.com"
    },
    {
        "key": "bootstrap",
        "badge": "Bootstrap",
        "color": "7952B3",
        "text": "Bootstrap",
        "url0": "https://getbootstrap.com/",
        "url1": "https://xconst.com"
    },

    
    


]

function getBadgeList(keywords){

    let retList=[]
    keywords.forEach(key => {
        let target= badgeList.find(badge=>{
            return (badge.key).toString()==(key)
        })
        if(target){
            retList.push(target)
            return;
        }
        target= badgeList.find(badge=>{
            return (badge.key).toString().includes(key)
        })
        retList.push(target)
    });
    
    return retList
}
export {badgeList,getBadgeList}